import { render, staticRenderFns } from "./DocumentLogs.vue?vue&type=template&id=18d3880c&"
import script from "./DocumentLogs.vue?vue&type=script&lang=js&"
export * from "./DocumentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports